import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PriceDisplay } from './PriceDisplay';
export function FinalCTA() {
  return <section className="py-16 px-4 md:py-24 bg-[#F5F5F5]" data-id="element-76">
      <div className="max-w-[600px] mx-auto text-center" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-78">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-gray-900 mb-4" data-id="element-79">
            ¿Seguís esperando el{' '}
            <span className="text-[#00A86B]" data-id="element-80">momento perfecto</span>?
          </h2>

          <p className="text-gray-700 text-lg mb-10" data-id="element-81">
            Tu Air Fryer te está esperando. Empezá hoy.{' '}
            <span className="text-[#00A86B] font-bold" data-id="element-82">Tu salud</span> te lo va
            a agradecer.
          </p>

          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-md border border-orange-50 mb-8 text-left max-w-sm mx-auto" data-id="element-83">
            <ul className="space-y-4" data-id="element-84">
              <li className="flex items-start gap-3" data-id="element-85">
                <div className="flex-shrink-0 w-5 h-5 rounded-full bg-[#00A86B] flex items-center justify-center mt-0.5" data-id="element-86">
                  <CheckIcon className="w-3.5 h-3.5 text-white" data-id="element-87" />
                </div>
                <span className="text-gray-900 font-medium text-sm md:text-base" data-id="element-88">
                  40 Recetas Keto para Air Fryer
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-89">
                <div className="flex-shrink-0 w-5 h-5 rounded-full bg-[#00A86B] flex items-center justify-center mt-0.5" data-id="element-90">
                  <CheckIcon className="w-3.5 h-3.5 text-white" data-id="element-91" />
                </div>
                <span className="text-gray-900 font-medium text-sm md:text-base" data-id="element-92">
                  Plan Keto 14 Días (BONUS)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-93">
                <div className="flex-shrink-0 w-5 h-5 rounded-full bg-[#00A86B] flex items-center justify-center mt-0.5" data-id="element-94">
                  <CheckIcon className="w-3.5 h-3.5 text-white" data-id="element-95" />
                </div>
                <span className="text-gray-900 font-medium text-sm md:text-base" data-id="element-96">
                  Untables Keto (BONUS)
                </span>
              </li>
            </ul>
          </div>

          <div className="mb-8" data-id="element-97">
            <p className="font-bold text-gray-900 mb-1" data-id="element-98">SOLO POR</p>
            <PriceDisplay amount={14500} className="font-heading font-extrabold text-[52px] text-[#00A86B] leading-none" data-id="element-99" />
          </div>

          <div className="w-full mb-6" data-id="element-100">
            <CTAButton data-id="element-101">QUIERO SOSTENER MI DIETA KETO DE VERDAD →</CTAButton>
          </div>

          {/* Bloque de pagos */}
          <div className="border-t border-gray-100 pt-5" data-id="element-102">
            <div className="flex justify-center items-center gap-5 mb-3" data-id="element-103">

              <img src="https://i.ibb.co/FLNVkjC4/Mercado-Pago-idw-Afz-US5-S-1.png" alt="Mercado Pago" style={{
              height: '32px',
              objectFit: 'contain',
              flexShrink: 0
            }} data-id="element-104" />

              <div className="w-px h-8 bg-gray-200" data-id="element-105"></div>

              <svg height="36" viewBox="0 0 116.5 72" xmlns="http://www.w3.org/2000/svg" style={{
              flexShrink: 0
            }} data-id="element-106">
                <rect x="0" y="0" width="116.5" height="72" rx="6" fill="white" stroke="#e5e7eb" strokeWidth="1" data-id="element-107" />
                <rect x="42.5" y="7.7" fill="#FF5F00" width="31.5" height="56.6" data-id="element-108" />
                <path fill="#EB001B" d="M44.5,36c0-11,5.1-21.5,13.7-28.3C42.6-4.6,20-1.9,7.7,13.8C-4.6,29.4-1.9,52,13.8,64.3c13.1,10.3,31.4,10.3,44.5,0C49.6,57.5,44.5,47,44.5,36z" data-id="element-109" />
                <path fill="#F79E1B" d="M116.5,36c0,19.9-16.1,36-36,36c-8.1,0-15.9-2.7-22.2-7.7c15.6-12.3,18.3-34.9,6-50.6c-1.8-2.2-3.8-4.3-6-6c15.6-12.3,38.3-9.6,50.5,6.1C113.8,20.1,116.5,27.9,116.5,36z" data-id="element-110" />
              </svg>

              <div className="w-px h-8 bg-gray-200" data-id="element-111"></div>

              <svg height="28" viewBox="0 0 262.3 85" xmlns="http://www.w3.org/2000/svg" style={{
              flexShrink: 0
            }} data-id="element-112">
                <path fill="#1434CB" d="M170.9,0c-18.6,0-35.3,9.7-35.3,27.5c0,20.5,29.5,21.9,29.5,32.1c0,4.3-5,8.2-13.4,8.2c-12,0-21-5.4-21-5.4l-3.8,18c0,0,10.3,4.6,24.1,4.6c20.4,0,36.4-10.1,36.4-28.3c0-21.6-29.6-23-29.6-32.5c0-3.4,4.1-7.1,12.5-7.1c9.5,0,17.3,3.9,17.3,3.9l3.8-17.4C191.3,3.6,182.8,0,170.9,0zM0.5,1.3L0,3.9c0,0,7.8,1.4,14.9,4.3c9.1,3.3,9.7,5.2,11.3,11.1l16.7,64.3h22.4L99.6,1.3H77.3l-22.1,56l-9-47.5c-0.8-5.4-5-8.5-10.2-8.5C36,1.3,0.5,1.3,0.5,1.3zM108.6,1.3L91.1,83.6h21.3l17.4-82.3L108.6,1.3zM227.2,1.3c-5.1,0-7.8,2.7-9.8,7.5l-31.2,74.8h22.3l4.3-12.5H240l2.6,12.5h19.7L245.2,1.3L227.2,1.3zM230.1,23.6l6.6,30.9H219L230.1,23.6z" data-id="element-113" />
              </svg>

            </div>

            <p className="text-gray-400 text-xs mb-4 flex items-center justify-center gap-1" data-id="element-114">
              🔒 Plataforma segura. Aboná con Mercado Pago.
            </p>

            <div className="flex flex-col sm:flex-row justify-center items-center gap-3 sm:gap-6 text-sm text-gray-600 font-medium" data-id="element-115">
              <div className="flex items-center gap-1.5" data-id="element-116">
                <svg className="w-4 h-4 text-[#00A86B]" fill="currentColor" viewBox="0 0 20 20" data-id="element-117"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414L8.414 15l-4.121-4.121a1 1 0 011.414-1.414L8.414 12.172l7.879-7.879a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-118" /></svg>
                <span data-id="element-119">Compra 100% segura</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-120">
                <svg className="w-4 h-4 text-[#00A86B]" fill="currentColor" viewBox="0 0 20 20" data-id="element-121"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414L8.414 15l-4.121-4.121a1 1 0 011.414-1.414L8.414 12.172l7.879-7.879a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-122" /></svg>
                <span data-id="element-123">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-124">
                <svg className="w-4 h-4 text-[#00A86B]" fill="currentColor" viewBox="0 0 20 20" data-id="element-125"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414L8.414 15l-4.121-4.121a1 1 0 011.414-1.414L8.414 12.172l7.879-7.879a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-126" /></svg>
                <span data-id="element-127">Descarga digital</span>
              </div>
            </div>
          </div>

        </motion.div>
      </div>
    </section>;
}